"use client";

import type { RootState } from "../store";

export const foreignNationalSelectors = {
  selectAll: (state: RootState) => state.foreignNational
};
